export const findMostCommon = <T>(
  items: T[],
  getKey?: (item: T) => string
): T | undefined => {
  const countMap = new Map<string, { count: number; item: T }>();
  let mostCommon: T | undefined;
  let maxCount = 0;

  for (const item of items) {
    const key = getKey ? getKey(item) : String(item);
    const entry = countMap.get(key) || { count: 0, item };
    entry.count += 1;
    countMap.set(key, entry);

    if (entry.count > maxCount) {
      maxCount = entry.count;
      mostCommon = entry.item;
    }
  }

  return mostCommon;
};
